export default {
  namespaced: true,
  state: {
    power: 1,
    plug: 1,
  },
  getters: {},
  actions: {
  },
  mutations: {
    SET(state, payload){
      state.power = payload.power_id;
      state.plug = payload.plug_id;
    },
  }
};
